import { render, staticRenderFns } from "./adminModal.vue?vue&type=template&id=8665512e"
import script from "./adminModal.vue?vue&type=script&lang=js"
export * from "./adminModal.vue?vue&type=script&lang=js"
import style0 from "./adminModal.vue?vue&type=style&index=0&id=8665512e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports